import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import { useProjectState } from "../../../context/stateContext";
import appActions from "../../../redux/getOrganizationAndRestaurant/actions";
import PageHeader from "../../../components/Common/PageHeader/PageHeader";
import MyMenuSurveyActions from "../../../components/User/MyMenuSurveyComponents/MyMenuSurveyActions";
import MyMenuSurveyTable from "../../../components/User/MyMenuSurveyComponents/MyMenuSurveyTable";

const { getRestaurants } = appActions;

const MyMenuSurvey = () => {
  const { selectedOrganization } = useProjectState();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getRestaurants());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOrganization]);

  return (
    <div>
      <PageHeader text="Анкети от MyMenu" date={true} />
      <MyMenuSurveyActions />
      <MyMenuSurveyTable />
    </div>
  );
};

export default MyMenuSurvey;
